/* eslint react/no-array-index-key: 1 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Grid, Table, TableBody, TableCell, TableRow, TablePagination } from '@material-ui/core';

import EnhancedTableHead from './EnhancedTableHead';
import TableFilters from './TableFilters';
import { stableSort, getSorting } from './tableHelpers';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        width: '100%',
        overflowX: 'auto',
        position: 'relative',
    },
});

const ConnectedTable = ({
    classes,
    className,
    labels = [],
    rows = [],
    intl,
    onRowClick,
    translationKey,
    filters,
}) => {
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);

    const handleRequestSort = (newOrderBy) => {
        if (orderBy === newOrderBy && order === 'desc') {
            setOrder('asc');
            return;
        }

        if (orderBy === newOrderBy && order === 'asc') {
            setOrder('');
            return;
        }

        setOrderBy(newOrderBy);
        setOrder('desc');
    };

    const handleChangePage = (event, newPage) => setPage(newPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const ignoreFieldsIndexes = [];
    labels.forEach((labelField, index) =>
        labelField.ignoreRender ? ignoreFieldsIndexes.push(index) : null
    );
    const filteredLabels = labels.filter((label) => !label.ignoreRender);

    return (
        <Grid className={classes.root}>
            {filters && <TableFilters filters={filters} intl={intl} />}
            <Table className={className}>
                <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                    labels={filteredLabels}
                    intl={intl}
                    translationKey={translationKey}
                />

                <TableBody>
                    {stableSort(rows, getSorting(order, orderBy))
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                            <TableRow
                                key={index}
                                onClick={() => onRowClick ? onRowClick(row) : null}
                                className={className}
                            >
                                {Object.values(row).map((item, index) => {
                                    if (ignoreFieldsIndexes.includes(index)) {
                                        return null;
                                    }

                                    let cellValue = item;
                                    if (typeof cellValue === 'boolean') {
                                        cellValue = cellValue ? 'True' : 'False';
                                    }

                                    return (
                                        <TableCell key={index} component="th" scope="row">
                                            {cellValue}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
            <TablePagination
                count={rows.length}
                component="div"
                rowsPerPageOptions={[5, 15, 25]}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                    inputProps: { 'aria-label': 'Rows per page' },
                    native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                backIconButtonProps={{
                    'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                    'aria-label': 'Next Page',
                }}
            />
        </Grid>
    );
};

export default withStyles(styles)(injectIntl(ConnectedTable));
